import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

const clientLogos = [
  { name: 'Glossop Cartons', image: '/glossop-cartons.webp' },
  { name: 'Hobbs', image: '/hobbs.webp' },
  { name: 'Latcham', image: '/latcham.webp' },
  { name: 'A1 Security Print', image: '/a1-security-print.webp' },
  { name: 'Elanders', image: '/elanders.webp' },
  { name: 'Mail Solutions', image: '/mail-solutions.webp' },
  { name: 'PMG', image: '/pmg.webp' },
  { name: 'Simply Cartons', image: '/simply-cartons.webp' },
  { name: 'Wetherby', image: '/wetherby.webp' },
];

const ClientLogos = () => {
  const [sectionRef, isSectionVisible] = useScrollReveal();
  const doubledLogos = [...clientLogos, ...clientLogos];

  return (
    <section className="py-20 lg:py-28 bg-white overflow-hidden">
      <div
        ref={sectionRef}
        className={`reveal ${isSectionVisible ? 'visible' : ''}`}
      >
        <div className="section-container mb-12">
          <span
            className="block text-sm font-semibold text-[#00BCE4] uppercase tracking-[3px] mb-2"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Here are just some of our clients
          </span>
        </div>

        {/* Scrolling Logo Track */}
        <div className="relative">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10"></div>

          <div className="overflow-hidden">
            <div className="logo-scroll-track">
              {doubledLogos.map((logo, index) => (
                <div
                  key={`${logo.name}-${index}`}
                  className="flex-shrink-0 mx-6 group"
                >
                  <div className="w-48 h-28 sm:w-64 sm:h-36 lg:w-72 lg:h-40 rounded-xl border border-gray-200 bg-white flex items-center justify-center p-3 sm:p-4 lg:p-5 transition-all duration-300 group-hover:border-[#00BCE4]/40 group-hover:shadow-lg group-hover:shadow-[#00BCE4]/5 group-hover:scale-105">
                    <img
                      src={logo.image}
                      alt={logo.name}
                      className="max-w-full max-h-full object-contain transition-transform duration-300"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
